import React, { ReactNode, useEffect } from 'react';
import styled from 'styled-components';

import { Description } from '~/atomic/atom/Description';
import Modal from '~/atomic/molecula/Modal';
import { PageTitleStyle } from '~/atomic/Typography';
import { paymentResultActions } from '~/feature/book/paymentResult/paymentResult.slice';
import { Error } from '~/feature/finance/BuyingSteps/Error';
import { saveBuyAbonnementInECommerce } from '~/feature/finance/ECommerce/saveBuyAbonnementInECommerce';
import {
  markPurchaseConversionTracked,
  wasPurchaseConversionTracked,
} from '~/feature/finance/trackedPurchaseConversions';
import { trackingBuyAbonnementInVkMetrika } from '~/feature/vk/VkMetrikaInit';
import { ym } from '~/feature/yandex/YandexMetrikaInit';
import { useAppDispatch, useAppSelector } from '~/store';

import {
  paymentResultSelector,
  resultModalSelectorFactory,
} from '../paymentResult/paymentResult.selector';

export const BuyAbonnementResultModal = (
  { onSuccess, buttons }:
  {
    onSuccess?: () => void;
    buttons: ReactNode[]
  },
) => {
  const dispatch = useAppDispatch();
  const { errorMessage, lastTransactionId } = useAppSelector(paymentResultSelector);
  const isSuccess = useAppSelector(resultModalSelectorFactory('buyAbonnementSuccess'));
  const isError = useAppSelector(resultModalSelectorFactory('buyAbonnementReject'));

  const closeErrorModal = () => {
    dispatch(paymentResultActions.closeModal('buyAbonnementReject'));
  };

  const closeSuccessModal = () => {
    dispatch(paymentResultActions.closeModal('buyAbonnementSuccess'));
  };

  const successBuyBookHandler = async () => {
    if (isSuccess) {
      // Дедупликация конверсий по транзакции — успех-модалка может открыться повторно
      // для уже обработанной транзакции (см. BuyBookResultModal).
      if (!wasPurchaseConversionTracked(lastTransactionId)) {
        ym('reachGoal', 'success-buy-abonnement');
        saveBuyAbonnementInECommerce(lastTransactionId);
        trackingBuyAbonnementInVkMetrika();
        markPurchaseConversionTracked(lastTransactionId);
      }
      if (onSuccess) onSuccess();
    }
  };

  useEffect(() => {
    successBuyBookHandler();
  }, [isSuccess]);

  return (
    <>
      <Modal
        open={isError}
        onCancel={closeErrorModal}
      >
        <Error error={errorMessage} onClose={closeErrorModal} />
      </Modal>
      <Modal
        open={isSuccess}
        onCancel={closeSuccessModal}
        width="540px"
      >
        <SCFinal>
          <SCTitle>
            Абонемент успешно оплачен.
            <br />
            Приятного чтения!
          </SCTitle>
          <Description data={[
            'Вы можете читать все книги, которые доступны в нашем Абонементе. При чтении платных глав с вашего абонемента будет списываться их объем в знаках.',
            'Ваш Абонемент автоматически продлится через 30 дней или в том случае, если вы прочитаете весь его объем в знаках раньше.',
          ]}
          />
          <SCButtonsWrap>
            {buttons}
          </SCButtonsWrap>
        </SCFinal>
      </Modal>
    </>
  );
};

const SCFinal = styled.div`
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const SCTitle = styled.h3`
  ${PageTitleStyle};
  margin-bottom: 22px;
  text-align: center;
`;

const SCButtonsWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
`;
